import React from "react";

import { SectionContainer } from "../../SectionContainer";
import { Tagline } from "../../Tagline/Tagline";
import { Headline } from "../../Headline";
import { Button } from "../../Button";

import { generateClassString as gcs } from "../../../lib/helper/generateClassString";

import * as styles from "./component.module.less";
import { StructuredTextRenderer } from "../../StructuredTextRenderer";

export function TeaserLayoutWrapper(
    {
        anker,
        tagline,
        headline,
        subheadline,
        semanticOfHeadline,
        link,
        wrapperClass,
        background,
        sectionClass,
        overviewPage,
        children
    },
    hasLightBackground
) {
    return (
        <SectionContainer
            background={background}
            sectionId={anker}
            sectionClass={gcs(styles.teaserSection, sectionClass)}
            containerClass={gcs(styles.teaserContainer)}
        >
            <div className={gcs(styles.teaserHeading, "reducedWidth")}>
                {tagline && <Tagline>{tagline}</Tagline>}

                {headline && (
                    <Headline semanticOfHeadline={semanticOfHeadline}>
                        {headline}
                    </Headline>
                )}

                {subheadline && <StructuredTextRenderer data={subheadline} />}
            </div>

            <div className={gcs(styles.teaserBottomLayout, wrapperClass)}>
                {children}

                {overviewPage?.label && overviewPage?.link && (
                    <Button
                        type={"primary"}
                        icon="arrowRight"
                        iconPosition="right"
                        renderAs="link"
                        to={overviewPage.link}
                        className={styles.teaserAllButton}
                    >
                        {overviewPage.label}
                    </Button>
                )}

                {/* <StructuredTextRenderer
                    data={link}
                    itemLinkType="primary"
                    itemLinkIcon="arrowRight"
                    itemLinkIconPosition="right"
                /> */}
            </div>
        </SectionContainer>
    );
}
